module.exports = __webpack_public_path__ + "static/media/dash-banking.581bcb11.svg";